// src/styles/displayStructureStyles.js
import { styled, withStyle } from 'baseui';

export const StructureTableArea = styled('div', ({ $theme }) => ({
  overflowY: 'hidden',
  overflowX: 'hidden',
  paddingTop: '0.5dvh',
  paddingRight: '0.5vw',
  paddingBottom: '0.5dvh',
  paddingLeft: '0.5vw',
  position: 'relative',
}));

export const ScrollableStructureTableWrapper = styled('div', ({ $theme }) => ({
  width: '100%',
  overflowX: 'auto',
  WebkitOverflowScrolling: 'touch',
}));

const StructureTableCellBase = styled('td', ({ $theme, $palette }) => ({
  borderTopWidth: '1px',
  borderRightWidth: '1px',
  borderBottomWidth: '1px',
  borderLeftWidth: '1px',
  borderStyle: 'solid',
  borderColor: $palette.borderOpaque,
  paddingTop: '0.5dvh',
  paddingRight: '0.3vw',
  paddingBottom: '0.5dvh',
  paddingLeft: '0.3vw',
  textAlign: 'center',
  whiteSpace: 'nowrap',
  color: $palette.contentPrimary,
}));

export const StyledTh = withStyle(StructureTableCellBase, ({ $theme, $palette }) => ({
  $as: 'th',
  fontSize: '4.0dvh',
  backgroundColor: $palette.tableHeader,
  fontWeight: 'bold',
  position: 'sticky',
  top: '0px',
  minWidth: '10vw',
  lineHeight: '1.5',
  [`@media screen and (max-width: ${$theme.breakpoints.medium - 1}px), screen and (min-width: ${$theme.breakpoints.medium}px) and (max-width: ${$theme.breakpoints.large - 1}px) and (orientation: portrait)`]: {
    fontSize: `2.0dvh`,
  },
}));

export const StyledTd = withStyle(StructureTableCellBase, ({ $theme, $palette, $isCurrent }) => ({
  fontSize: '5.0dvh',
  minWidth: '10vw',
  lineHeight: '1.75',
  color: $isCurrent ? $palette.backgroundPrimary : $palette.contentPrimary,
  [`@media screen and (max-width: ${$theme.breakpoints.medium - 1}px), screen and (min-width: ${$theme.breakpoints.medium}px) and (max-width: ${$theme.breakpoints.large - 1}px) and (orientation: portrait)`]: {
    fontSize: `2.0dvh`,
  },
}));

export const DisplayStructureTable = styled('table', ({ $theme, $palette }) => ({
  width: '100%',
  borderCollapse: 'collapse',
  backgroundColor: $palette.backgroundPrimary,
  border: `1px solid ${$palette.borderOpaque}`,
}));

export const StructureTableRow = styled('tr', ({ $theme, $palette, $isCurrent }) => ({
  backgroundColor: $isCurrent ? $palette.highlightBackground : 'transparent',
}));